import { yup } from '@framework/validation';
import { ExpressionType } from '../../IExpression';
import { createExpressionType } from '../../IExpressionType';
import { ReferencePlainValueSchema } from '../../validation/ReferencePlainValueSchema';
import { IValueExpression } from './IValueExpression';

export const ValueExpressionType = createExpressionType<IValueExpression>({
  type: ExpressionType.Value,
  schema: yup
    .object({
      type: yup
        .string()
        .exact(ExpressionType.Value)
        .required()
        .default(ExpressionType.Value),
      value: ReferencePlainValueSchema.label('Valore')
        .default(null)
        .defined()
        .nullable(),
    })
    .noUnknown(),
  evaluate(expression, scope) {
    return expression.value;
  },
  getReferences(expression: IValueExpression) {
    return [];
  },
  toString(expression) {
    return expression.value?.toString() ?? 'null';
  },
});
